module.exports = __webpack_public_path__ + "static/media/docker-plain.ff73f4ac.svg";